"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_use_measure_1 = __importDefault(require("react-use-measure"));
const lodash_1 = require("lodash");
const Tab_1 = __importDefault(require("@material-ui/core/Tab"));
const Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
const form_context_1 = require("../form/form-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const tabs_styles_1 = require("./tabs-styles");
function useView() {
    const { search } = (0, react_router_dom_1.useLocation)();
    const params = new URLSearchParams(search);
    return params.get('view');
}
function Tabs({ config, onClick, }) {
    const classes = (0, tabs_styles_1.useStyles)('#fafafa', 10)();
    const [activeTab, setActiveTab] = (0, react_1.useState)(0);
    const { errors } = (0, react_1.useContext)(form_context_1.FormContext);
    const [tabsWrapperRef] = (0, react_use_measure_1.default)();
    const route = (0, react_router_dom_1.useRouteMatch)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const view = useView();
    (0, react_1.useEffect)(() => {
        const index = config.findIndex((tab) => tab.key === view);
        setActiveTab(index === -1 ? 0 : index);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [view]);
    const handleTabChange = (0, event_callback_hook_1.useEventCallback)((_, index) => {
        const tab = config[index];
        if (onClick) {
            onClick(setActiveTab, tab);
        }
        else {
            history.push(`${route.url}?view=${tab.key}`, location.state);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.tabsWrapper, ref: tabsWrapperRef },
            react_1.default.createElement(Tabs_1.default, { className: classes.tabs, variant: "scrollable", value: activeTab, onChange: handleTabChange, classes: {
                    indicator: classes.indicator,
                    root: classes.tabsRoot,
                    scrollButtons: classes.scrollButtons,
                } }, config.map((tab, i) => {
                var _a;
                const validationErrorsCount = (0, lodash_1.intersection)(errors.map((error) => error.key), (_a = config[i].validationKeys) !== null && _a !== void 0 ? _a : []).length;
                return (!config[i].hide && (react_1.default.createElement(Tab_1.default, { key: i, label: react_1.default.createElement("div", { className: classes.tabLabel },
                        tab.label,
                        validationErrorsCount > 0 && (react_1.default.createElement("span", { className: classes.errorCount }, validationErrorsCount))), classes: {
                        root: classes.tabRoot,
                    } })));
            }))),
        config[activeTab].content));
}
exports.Tabs = Tabs;
//# sourceMappingURL=tabs.js.map